import { useCallback, useEffect, useRef, useState } from 'react';

// useIsComponentCropped from common-utils only checks horizontal overflow and lacks ResizeObserver,
// so it doesn't cover multi-line clamped text that can overflow vertically.
const checkTruncation = el => el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;

export const useIsTruncated = children => {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const updateTruncation = useCallback(() => {
    if (textRef.current) {
      setIsTruncated(checkTruncation(textRef.current));
    }
  }, []);

  useEffect(() => {
    const el = textRef.current;
    if (!el) return;

    updateTruncation();

    // Observe the parent so we detect when available space grows (the element
    // itself won't resize when overflow:hidden keeps it clipped).
    const target = el.parentElement || el;
    const observer = new ResizeObserver(updateTruncation);
    observer.observe(target);

    return () => observer.disconnect();
  }, [updateTruncation, children]);

  return { isTruncated, textRef };
};
